/**
 * @generated SignedSource<<910227e304f60e0353f9ea75e4338816>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OriginalListPrice_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useOriginalListPrice_item">;
  readonly " $fragmentType": "OriginalListPrice_item";
};
export type OriginalListPrice_item$key = {
  readonly " $data"?: OriginalListPrice_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"OriginalListPrice_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": "pdp",
      "kind": "LocalArgument",
      "name": "page"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "OriginalListPrice_item",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "page",
          "variableName": "page"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useOriginalListPrice_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "f75e5ac6981611a1925b960b98353444";

export default node;
